import { render, staticRenderFns } from "./HDTratamientosViewOnly.vue?vue&type=template&id=f24fb212&scoped=true"
import script from "./HDTratamientosViewOnly.vue?vue&type=script&lang=js"
export * from "./HDTratamientosViewOnly.vue?vue&type=script&lang=js"
import style0 from "./HDTratamientosViewOnly.vue?vue&type=style&index=0&id=f24fb212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24fb212",
  null
  
)

export default component.exports